/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import analytics from "analytics/analytics";
import baustein from "baustein";
import ShippingAndReturnsOverlay from "components/overlays/shipping-and-returns-overlay";

export const SHIPPING_AND_RETURNS_LINK_SELECTOR = ".buybuybuy-option__shipping-and-returns-link";
const BUY_BUTTON_SELECTOR = ".buybuybuy-option__buy-button";

/**
 * NEW BUY OPTION IN NEW PDP
 *
 * This is part of a new iteration of our PDP that's behind the `buybuybuy` Heimdall.
 * Being a test, is not all the refined it could be.
 *
 * @see components/buybuybuy-area
 * @see components/buybuybuy-options
 */
export default baustein.register("buybuybuy-option", {
    defaultOptions: {
        linkId: null,
        rawSize: null,
        price: null,
        discount: null,
        retailerSlug: null,
        onFinalSale: null,
        hasFreeShipping: null
    },

    setupEvents(add) {
        add("click", SHIPPING_AND_RETURNS_LINK_SELECTOR, this._onShippingInfoClick);
        add("click", BUY_BUTTON_SELECTOR, this._onBuyAction);
    },

    _onShippingInfoClick(event) {
        event.preventDefault();

        const linkId = this.options.linkId;
        const shippingAndReturnsOverlay = new ShippingAndReturnsOverlay({ linkId });

        // append overlay to the document body, because this component will typically
        // be shown in an accordion, which is position relative and overflow hidden
        // so would not display correctly
        shippingAndReturnsOverlay.appendTo(document.body);
        shippingAndReturnsOverlay.open();
        analytics.event("buy_area", "show_shipping_and_returns");
    },

    _onBuyAction(event, target) {
        this.emit("buyOptionAddToBag", { options: this.options, target: target });
    }
});

